import { render } from "./CardResult.vue?vue&type=template&id=6a2a602a&scoped=true"
import script from "./CardResult.vue?vue&type=script&lang=js"
export * from "./CardResult.vue?vue&type=script&lang=js"

import "./CardResult.vue?vue&type=style&index=0&id=6a2a602a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2a602a"]])

export default __exports__